import { render } from "./powered_by.html?vue&type=template&id=22dc63d6&external"
import script from "./powered_by.js?vue&type=script&lang=js&external"
export * from "./powered_by.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__